import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard, MenuResolver } from '../_shared';

import { DashboardComponent } from '../dashboard/dashboard.component';
import { NotFoundComponent } from '../not-found/not-found.component';
import { LegalAgreementComponent } from '../legal-agreement/legal-agreement.component';
import { ProfileComponent } from '../profile/profile.component';
import { NotificationsComponent } from '../notifications/notifications.component';
import { SearchResultComponent } from '../search-result/search-result.component';
import { NavbarComponent } from './navbar.component';

// Ticket Menu
import {
  AllTicketsComponent,
  MyTicketsComponent,
  TicketDetailComponent,
  TicketMonitoringComponent
} from '../ticket';

// User Management Menu
import {
  UserLevelComponent,
  AdministratorComponent,
  ClientComponent,
  DivisionComponent
} from '../user-management';

const navbarRoutes: Routes = [
  {
    path: '',
    component: NavbarComponent,
    canActivate: [AuthGuard],
    resolve: {
      menu: MenuResolver
    },
    children: [
      // dashboard
      {
        path: 'dashboard',
        component: DashboardComponent,
        canActivate: [AuthGuard],
        data: { title: 'Dashboard' }
      },
      {
        path: 'notifications',
        component: NotificationsComponent,
        canActivate: [AuthGuard],
        data: { title: 'Your Notifications' }
      },
      {
        path: 'searchresult/:searchkey',
        component: SearchResultComponent,
        canActivate: [AuthGuard],
        data: { title: 'Search Result' }
      },
      // legal agreement page
      {
        path: 'legalagreement',
        component: LegalAgreementComponent,
        canActivate: [AuthGuard],
        data: { title: 'Legal Agreement' }
      },
      // ticketing menu
      {
        path: 'ticketing/alltickets',
        component: AllTicketsComponent,
        canActivate: [AuthGuard],
        data: { title: 'All Tickets' }
      },
      {
        path: 'ticketing/mytickets',
        component: MyTicketsComponent,
        canActivate: [AuthGuard],
        data: { title: 'My Tickets' }
      },
      {
        path: 'ticketing/monitoring',
        component: TicketMonitoringComponent,
        canActivate: [AuthGuard],
        data: { title: 'Ticket Monitoring' }
      },
      {
        path: 'ticketing/alltickets/detail/:id',
        component: AllTicketsComponent,
        canActivate: [AuthGuard],
        data: { title: 'All Tickets - Detail' }
      },
      {
        path: 'ticketing/mytickets/detail/:id',
        component: MyTicketsComponent,
        canActivate: [AuthGuard],
        data: { title: 'My Tickets - Detail' }
      },
      // User Management Menu
      {
        path: 'usermanagement/administrator',
        component: AdministratorComponent,
        canActivate: [AuthGuard],
        data: { title: 'Administrator' }
      },
      {
        path: 'usermanagement/clients',
        component: ClientComponent,
        canActivate: [AuthGuard],
        data: { title: 'Administrator' }
      },
      {
        path: 'usermanagement/userlevel',
        component: UserLevelComponent,
        canActivate: [AuthGuard],
        data: { title: 'Profile' }
      },
      {
        path: 'usermanagement/division',
        component: DivisionComponent,
        canActivate: [AuthGuard],
        data: { title: 'Division' }
      },
      // Profile Menu
      {
        path: 'profile',
        component: ProfileComponent,
        canActivate: [AuthGuard],
        data: { title: 'Profile' }
      },
      // 404 Not Found Page
      {
        path: 'not-found',
        component: NotFoundComponent,
        data: { title: 'Not Found' }
      },
      {
        path: '**',
        redirectTo: '/not-found',
        pathMatch: 'full'
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(navbarRoutes)],
  exports: [RouterModule]
})
export class NavbarRoutingModule {}



// WEBPACK FOOTER //
// D:/Work-Local/frontend/src/app/navbar/navbar-routing.module.ts